var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.25 7.25H13.75V8.75H2.25V7.25Z","fill":"#181818"}));
}

Minus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
